import { QueryObserverOptions, useQuery } from "react-query";
import { APIError, APIResponse, API_URL_V3, get } from "../api";
import type { QuickLoanRepaymentScheduleItem } from "../@types";
import { normalizeRepaymentSchedule } from "../helpers/loanSchedule";

const BASE = API_URL_V3 + "/alert/loan/quick-loans";

function useLoanRepaymentSchedule(
  loanId: string,
  options?: QueryObserverOptions<
    APIResponse<QuickLoanRepaymentScheduleItem[]>,
    APIError
  > & { enabled?: boolean }
) {
  const {
    isLoading: isLoadingSchedule,
    isError: isScheduleError,
    data: scheduleResponse,
    refetch: refetchSchedule,
  } = useQuery<APIResponse<QuickLoanRepaymentScheduleItem[]>, APIError>(
    ["loan-repayment-schedule", loanId],
    async () => {
      const res = await get(BASE + "/" + encodeURIComponent(loanId) + "/repayment-schedule", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      const data = (res as any)?.data;
      return {
        status: true,
        data: normalizeRepaymentSchedule(data),
        message: (res as any)?.message,
      } as APIResponse<QuickLoanRepaymentScheduleItem[]>;
    },
    { enabled: !!loanId, ...options }
  );

  return {
    isLoadingSchedule,
    isScheduleError,
    schedule: scheduleResponse?.data ?? [],
    scheduleResponse,
    refetchSchedule,
  };
}

export default useLoanRepaymentSchedule;
